import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { AnalyticsFetchTopSourcesResponse } from 'src/services/__generated__/api'

const getAllTopSources = async (
  start?: string,
  end?: string
): Promise<AnalyticsFetchTopSourcesResponse> => {
  const { data } = await AnalyticsApi.v1Private.analyticsFetchTopSourcesList({
    fromDate: start,
    toDate: end,
  })
  return data
}

interface UseGetAllTopSourcesQueryParams {
  end?: string
  start?: string
}

export const useGetAllTopSourcesQuery = (
  params: UseGetAllTopSourcesQueryParams
) => {
  return useQuery({
    queryFn: () => getAllTopSources(params.start, params.end),
    queryKey: [
      QueryKey.GET_TOP_SOURCES_BY_CAMPAIGN,
      'all',
      params.start,
      params.end,
    ],
  })
}
